<template>
  <div class="sj-panel-year">
    <div
      :class="[
        'sj-panel-year-item',
        {
          current: dateItem.current
        }
      ]"
      v-for="dateItem in dateList"
      :key="dateItem.date"
      @click="handleClick(dateItem)"
      @mouseenter="handleMouseenter(dateItem)"
    >
      <div
        :class="[
          'sj-panel-year-item-inner',
          {
            'is-range': getItemIsRange(dateItem),
            'start-date': getItemIsStartOrEndDate(dateItem),
            'end-date': getItemIsStartOrEndDate(dateItem, 'end'),
            selected: getItemSelected(dateItem)
          }
        ]"
      >
        <span>{{ dateItem.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import mixin from "./mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      formatYear: "YYYY",
      dateNum: 20,
      dateList: []
    };
  },
  computed: {
    formatValue() {
      const { value, range, multiple, formatYear, formatYearTime } = this;
      if (!range) {
        const getValue = val => {
          if (typeof val === "number") {
            return moment(val).format(formatYear);
          }
          return "";
        };
        if (!multiple) {
          return getValue(value);
        } else {
          if (Array.isArray(value)) {
            return value.map(item => getValue(item));
          }
          return [];
        }
      } else {
        if (
          Object.prototype.toString.call(value) === "[object Array]" &&
          value[0] &&
          typeof value[0] === "number" &&
          value[1] &&
          typeof value[1] === "number"
        ) {
          return [formatYearTime(value[0]), formatYearTime(value[1])];
        }
        return [];
      }
    }
  },
  methods: {
    getDateList() {
      const { currentDate, formatYear, dateNum } = this;

      const dateList = [];
      const currentYearNum = moment(currentDate).year();
      const startYear = Math.floor(currentYearNum / dateNum) * dateNum;
      const currentStr = moment().format(formatYear);
      for (let i = 0; i < dateNum; i += 1) {
        const yearDate = moment(`${startYear + i}`, "YYYY");
        const yearLabel = yearDate.format(formatYear);
        const dateItem = {
          current: currentStr === yearLabel,
          date: yearLabel,
          dateTime: yearDate.toDate().getTime(),
          label: yearLabel
        };
        dateList.push(dateItem);
      }
      this.dateList = dateList;
    },
    formatYearTime(time) {
      const { formatYear } = this;
      return moment(moment(time).format(formatYear), formatYear)
        .toDate()
        .getTime();
    },
    handleClick(item) {
      const { range, multiple, value } = this;
      if (!range) {
        const inputValue = item.dateTime;
        if (multiple) {
          const nowVal = Array.isArray(value) ? [...value] : [];
          const index = nowVal.indexOf(inputValue);
          if (index === -1) {
            nowVal.push(inputValue);
          } else {
            nowVal.splice(index, 1);
          }
          this.$emit("input", nowVal);
        } else {
          this.$emit("input", inputValue);
          this.$emit("close");
        }
      } else {
        const { choosing } = this;
        this.$emit("update:choosing", !choosing);
        if (!choosing) {
          this.$emit("input", [item.dateTime, item.dateTime]);
          this.$emit("update:chooseStartValue", item.dateTime);
        } else {
          this.$emit("close");
        }
      }
    },
    handleMouseenter(item) {
      const { choosing, chooseStartValue } = this;
      if (choosing) {
        const valueList = [chooseStartValue, item.dateTime].sort(
          (a, b) => a - b
        );
        this.$emit("input", valueList);
      }
    },
    getItemIsRange(dateItem) {
      const { range, formatValue } = this;
      if (range) {
        return (
          dateItem.dateTime >= formatValue[0] &&
          dateItem.dateTime <= formatValue[1]
        );
      }
      return false;
    },
    getItemIsStartOrEndDate(dateItem, type = "start") {
      const index = type === "start" ? 0 : 1;
      const { range, formatValue } = this;
      if (range) {
        return formatValue[index] === dateItem.dateTime;
      }
      return false;
    },
    getItemSelected(dateItem) {
      const { range, multiple, formatValue } = this;
      if (!range) {
        if (!multiple) {
          return formatValue === dateItem.date;
        } else {
          let flag = false;
          for (let i = 0; i < formatValue.length; i += 1) {
            if (formatValue[i] === dateItem.date) {
              flag = true;
              break;
            }
          }
          return flag;
        }
      }
      return false;
    }
  },
  watch: {
    currentDate: {
      immediate: true,
      handler() {
        this.getDateList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sj-panel-year {
  text-align: center;
  padding: 5px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(5, 48px);
  align-items: center;

  .sj-panel-year-item {
    .text("caption", "available");
    cursor: pointer;

    &:hover {
      .sj-panel-year-item-inner:not(.selected):not(.start-date):not(.end-date) {
        span {
          background-color: @color-productlight;
        }
      }
    }

    &.current {
      color: @color-highlight;
    }

    .sj-panel-year-item-inner {
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
      }
    }

    .selected,
    .start-date,
    .end-date {
      span {
        background-color: @color-highlight;
        color: @color-antibg;
      }
    }

    .is-range {
      background-color: @color-productlight;

      &.start-date,
      &.end-date {
        background-color: transparent;
      }

      &.start-date:not(.end-date) {
        background: linear-gradient(
          to right,
          transparent 50%,
          @color-productlight 50%
        );
      }

      &.end-date:not(.start-date) {
        background: linear-gradient(
          to right,
          @color-productlight 50%,
          transparent 50%
        );
      }
    }
  }
}
</style>
